/**
 *  Numeric symbols
 */
export const defaultNumericSymbols = [" K", " Mln", " Bln"];

/**
 *  use the below colors on drilldonwn mode.
 */
export const defaultChartColors = {
  /**
   * Recommended for most recent year.
   */
  black: "#444852",
  /**
   * Recommended for oldest year.
   */
  grey: "#b4bbcb",
};

export const GenericHighChartsOptions: Highcharts.Options = {
  chart: {
    style: {
      fontFamily: "Roboto",
      fontSize: "14px",
    },
  },
  credits: {
    enabled: false,
  },
  lang: {
    decimalPoint: ".",
    numericSymbols: defaultNumericSymbols,
    thousandsSep: ",",
  },
  legend: {
    itemStyle: {
      fontFamily: "Roboto",
      fontSize: "14px",
    },
  },
  plotOptions: {
    series: {
      dataLabels: {
        style: {
          fontFamily: "Roboto",
          fontSize: "14px",
        },
      },
      label: {
        style: {
          fontFamily: "Roboto",
          fontSize: "14px",
        },
      },
    },
  },
  title: {
    text: "",
  },
  tooltip: {
    headerFormat:
      '<span style="font-size: 14px; font-family:Roboto">{point.key}</span><br/>',
    style: {
      fontFamily: "Roboto",
      fontSize: "14px",
    },
  },
  xAxis: {
    labels: {
      style: {
        fontFamily: "Roboto",
        fontSize: "14px",
      },
    },
  },
  yAxis: {
    labels: {
      style: {
        fontFamily: "Roboto",
        fontSize: "14px",
      },
    },
    title: {
      style: {
        fontFamily: "Roboto",
        fontSize: "14px",
      },
    },
  },
};
